import { Redirect } from '#app/components/Redirect/index.js';
import { useLocation } from '#app/hooks/useLocation.js';
import { getRoute } from '@contra/routes';

export const Page = () => {
  const location = useLocation();

  const discoveryRoutes = getRoute('/discover/independents');
  const queryParameters = location.search;
  const targetPath = `${discoveryRoutes}${queryParameters}`;
  return (
    <Redirect
      method="replace"
      to={targetPath}
    />
  );
};
